import React from "react";
import Grid from "@material-ui/core/Grid";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import {
    numberWithCommaDataTableTemplate,
    rateMultipliedByOneHundredDataTableTemplate
} from "../../../utils/formatters/Numbers";
import HeaderScreenPresval from "../../../components/headerScreenPresval";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const ExtensionAdmin = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <HeaderScreenPresval headerTitle="Operación \ Prórrogas Administrativas"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.getProrrogaAdmin}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-4 p-col-4">
                                    <SubtitleLabel header="Prestamista" isBold={true}/>
                                    <Dropdown
                                        name="catInstitutionLenderFilter"
                                        filter={true}
                                        filterBy="nombreCorto"
                                        options={props.catInstitutionCatalog}
                                        optionLabel="nombreCorto"
                                        placeholder="Seleccione..."
                                        onChange={props.saveFilters}
                                        value={props.catInstitutionLenderFilter}/>
                                </div>
                                <div className="p-col-12 p-md-4 p-col-4">
                                    <SubtitleLabel header="Prestatario" isBold={true}/>
                                    <Dropdown
                                        name="catInstitutionBorrowerFilter"
                                        filter={true}
                                        filterBy="nombreCorto"
                                        options={props.catInstitutionCatalog}
                                        optionLabel="nombreCorto"
                                        placeholder="Seleccione..."
                                        onChange={props.saveFilters}
                                        value={props.catInstitutionBorrowerFilter}/>
                                </div>
                                <div className="p-col-12 p-md-4 p-col-4">
                                    <br/>
                                    <Button style={{'float': 'right'}}
                                            label="Limpiar"
                                            className="p-button-secondary"
                                            onClick={props.clearFilters}/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>

                    <Grid item xs={12}>
                        <DataTable
                            value={props.extensionAdminList}
                            selectionMode="single"
                            responsive={true}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column field="idFolioPrest" header="Folio"
                                    style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="statusPV" header="Estatus"
                                    style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="nomCortoPTM" header="Prestamista"
                                    style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="nomCortoPTT" header="Prestatario"
                                    style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="emision" header="Emisora"
                                    style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="cantPrestamo" header="Títulos"
                                    style={{textAlign: 'right'}}
                                    body={numberWithCommaDataTableTemplate} sortable={true}/>
                            <Column field="plazo" header="Plazo"
                                    style={{textAlign: 'right'}}
                                    body={numberWithCommaDataTableTemplate} sortable={true}/>
                            <Column field="tasa" header="Tasa"
                                    style={{textAlign: 'right'}}
                                    body={rateMultipliedByOneHundredDataTableTemplate} sortable={true}/>
                            <Column field="sobreTasa" header="Sobretasa"
                                    style={{textAlign: 'right'}}
                                    body={rateMultipliedByOneHundredDataTableTemplate} sortable={true}/>
                            <Column header="Acciones"
                                    body={props.extensionActionTemplate}
                                    style={{textAlign: 'center', width: '180px'}}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default ExtensionAdmin;